import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IManagableObject } from "../system/admin-panel/IManagableObject";

interface ObjectDiagnosticsResponse {
  objectId: number;
  objectName: string | null;
  companyId: number;
  companyName: string | null;
  status: number;
  deviceModel: string | null;
  phone: string | null;
  phone1: string | null;
  imei: string | null;
  time: number | null;
  lastFuel: string | null;
  lastPower: string | null;
  lowPower: boolean | null;
  online: boolean | null;
  lat: number | null;
  lng: number | null;
  sat: number | null;
  accuracy: number | null;
  odometer: number | null;
  engineTime: number | null;
}

export class ObjectDiagnosticsModel implements IManagableObject  {
  IsChecked = false;
  Id: number = 0;
  Name: string = "";
  CompanyId: number = 0;
  CompanyName: string = "";
  Status: number = 0;
  DeviceModel: string = "";

  Phone: string = "";
  Phone1: string = "";
  IMEI: string = "";

  Time = 0;

  LastFuel = "";
  LastPower = "";
  LowPower = false;
  Online = false;
  Lat = 0;
  Lng = 0;
  Sat = 0;
  Accuracy = 0;
  Odometer = 0;
  EngineTime = 0;
  Address = '';

  init(data?: ObjectDiagnosticsResponse): void {
    if (data) {
      this.Id = data.objectId;
      this.Name = data.objectName ?? "";
      this.CompanyId = data.companyId;
      this.CompanyName = data.companyName ?? "";
      this.Status = data.status;
      this.DeviceModel = data.deviceModel ?? "";
      this.Time = data.time ?? 0;

      this.Phone = data.phone ?? "";
      this.Phone1 = data.phone1 ?? "";
      this.IMEI = data.imei ?? "";

      this.LastFuel = data.lastFuel ?? "";
      this.LastPower = data.lastPower ?? "";
      this.LowPower = data.lowPower ?? false;
      this.Online = data.online ?? false;
      this.Lat = data.lat ?? 0;
      this.Lng = data.lng ?? 0;
      this.Sat = data.sat ?? 0;
      this.Accuracy = data.accuracy ?? 0;
      this.Odometer = data.odometer ?? 0;
      this.EngineTime = data.engineTime ?? 0;
    }
  }

  static fromJS(data: ObjectDiagnosticsResponse): ObjectDiagnosticsModel {
    let result = new ObjectDiagnosticsModel();
    result.init(data);
    return result;
  }
}




@Injectable()
export class DiagnosticsService {

  constructor(private client:HttpClient) {

  }

  public GetReport(): Observable<ObjectDiagnosticsModel[]> {
    return this.client.get<ObjectDiagnosticsResponse[]>("/ctrl/diagnostics").pipe(map(values => {
      const result: ObjectDiagnosticsModel[] = [];
      for (const item of values ?? [])
        result.push(ObjectDiagnosticsModel.fromJS(item));
      return result;
    }))
  }
}
